import { FUEL_OPTIONS } from '../../common/constants';

/**
 * Gets the English version of the fuel option by its label or value
 * @param {string} labelOrValue - The label or value of the fuel option to find
 * @returns {FUEL_OPTIONS[0]|undefined} - The matching English version fuel option or undefined if not found
 */
export default function getFuelOption(labelOrValue) {
  return labelOrValue && FUEL_OPTIONS.find(o => o.label === labelOrValue || o.value === Number(labelOrValue));
}
